import { Button, ButtonProps, message } from "antd";
import { FC, useState } from "react";
import { renderErrorMessage } from "../../../../components/messages/errorMessage";
import SavedMessage from "../../../../components/messages/savedMessage";
import LeasingStore from "../../../../contexts/leasingStore";
import _t from "../../../../lang/translate";
import { unGenerateContracts } from "../../../../services/leasingService";
import Icon from "../../../../assets/icons/icon";
import PopoverList from "../../../../components/popups/popoverList";

const OpenContractsButton: FC<ButtonProps> = (props) => {
  const { leasingCase, setLeasingCase } = LeasingStore.useContainer();
  const [loading, setLoading] = useState<boolean>(false);
  const { contractGenerated, readonly } = leasingCase.flags;
  const disabled = !contractGenerated || readonly;

  const handleOpenContract = async () => {
    try {
      setLoading(true);
      const { data } = await unGenerateContracts(leasingCase.id);
      message.success(<SavedMessage />);
      setLeasingCase({ ...leasingCase, ...data });
    } catch (error) {
      renderErrorMessage(error)
    } finally {
      setLoading(false);
    }
  };
  return (
    <PopoverList list={[
      !contractGenerated ? "Kontrakter er ikke genereret endnu" : null,
      readonly ? _t("msg.case_is_readonly") : null,
    ].filter(Boolean) as string[]}>
      <Button {...props} loading={loading} disabled={disabled} onClick={handleOpenContract} icon={<Icon size="medium" name="refresh-outline" />}>
        {_t("reopen")}
      </Button>
    </PopoverList>
  );
};

export default OpenContractsButton;
